<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style src='./assets/css/sticky-footer-navbar.css'></style>

<style src='./assets/css/beeper.css'></style>

<style>
/* .dg-btn--ok {
  border-color: green;
  color:green;
}

.dg-btn--cancel {
  border-color: red;
  background-color: white;
  color:red;
}

.dg-btn-loader .dg-circle {
  background-color: green;
} */
</style>


// WEBPACK FOOTER //
// src/App.vue